import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { RootState } from "app/lib/store/store";
import { useDispatch, useSelector } from "react-redux";
import InputField from "app/components/common/inputs/InputField";

import {
  nextStep,
  setStep,
  addStepsData,
} from "app/lib/store/slices/steps/loanTypesSteps";

import MainTitle from "app/components/common/typography/MainTitle";
import ContinueButton from "app/components/common/buttons/Continue";
import PreviousButtom from "app/components/common/buttons/Previous";
import ProgressBar from "app/components/common/progressbar/ProgressBar";
import SubTitle from "app/components/common/typography/SubTitle";
import SelectField from "app/components/common/inputs/SelectField";

interface FormData {
  model: string;
  year: string | number;
  make: string;
}
interface AddManuallyModelProps {
  isCarBrand?: boolean;
}

const AddManuallyModel: React.FC<AddManuallyModelProps> = ({
  isCarBrand = false,
}) => {
  const dispatch = useDispatch();
  const { vehicleDetail, ...remaingData } = useSelector(
    (state: RootState) => state.loanTypesSteps.stepsData
  );
  const {
    handleSubmit,
    control,
    formState: { errors },
    setValue,
  } = useForm<FormData>();

  const currentYear = new Date().getFullYear();
  const yearsOptions = Array.from({ length: 13 }, (_, i) => {
    const year = currentYear - i;
    return { value: year, label: year.toString() };
  });
  const minYear = currentYear - 12;

  const onSubmit = (data: FormData) => {
    const { model, year, make } = data;
    dispatch(
      addStepsData({
        ...remaingData,
        vehicleDetail: {
          ...vehicleDetail,
          model,
          make,
          year: Number(year),
        },
      })
    );
    if (isCarBrand) {
      dispatch(setStep(5));
    } else {
      dispatch(nextStep());
    }
  };

  useEffect(() => {
    if (vehicleDetail) {
      setValue("make", vehicleDetail.make || "");
      setValue("model", vehicleDetail.model || "");
      setValue("year", vehicleDetail.year || "");
    }
  }, [vehicleDetail, setValue]);

  const handleprevius = () => {
    const step = vehicleDetail?.isCarManuallyModel ? 2 : 3;
    dispatch(setStep(step));
  };

  return (
    <>
      <ProgressBar progress={40} />
      <div className="w-full  sm:w-[70%] xl:w-[45%] mx-auto text-center px-4 sm:px-0">
        <MainTitle title="Select Model" />
        <SubTitle title="Search for your preferred vehicle model. If you're unsure, you can select from the available options." />

        <form onSubmit={handleSubmit(onSubmit)}>
          <div className="flex flex-col sm:flex-row justify-between gap-6">
            <div className="flex-1">
              <InputField
                label="Make"
                name={"make"}
                control={control}
                type="text"
                required={true}
                placeholder="Ford"
                error={errors.make?.message}
                className="flex-1"
                rules={{
                  required: "Make is required",
                }}
              />
            </div>
            <div className="flex-1 ">
              <div className="flex gap-6">
                <InputField
                  label="Model"
                  name={"model"}
                  control={control}
                  type="text"
                  required={true}
                  placeholder="Fiesta"
                  error={errors.model?.message}
                  className="flex-1"
                  rules={{
                    required: "Model is required",
                  }}
                  removePosition={true}
                />
                <SelectField
                  label="Year"
                  name="year"
                  control={control}
                  options={yearsOptions}
                  placeholder="2024"
                  error={errors.year?.message}
                  required={true}
                  className="flex-1"
                  rules={{
                    validate: (value: string | number) => {
                      const year = Number(value);
                      if (!year) return "Please select a valid year";
                      if (year < minYear || year > currentYear) {
                        return `Please select a year between ${minYear} and ${currentYear}`;
                      }
                      return true;
                    },
                  }}
                  removePosition={true}
                />
              </div>
            </div>
          </div>

          <div className="flex justify-between my-10">
            <PreviousButtom onClick={handleprevius}>Previous</PreviousButtom>
            <ContinueButton type="submit">Next</ContinueButton>
          </div>
        </form>
      </div>
    </>
  );
};

export default AddManuallyModel;
